import InvitationEmail from "./InvitationEmail";
export default InvitationEmail;
